module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal-setting"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("下单设置")]), _vm._v(" "), _c('div', {
    staticClass: "setting-item"
  }, [_c('div', [_c('span', [_vm._v("是否开启云拆？")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "是",
      "inactive-text": "否",
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.splitMode),
      callback: function($$v) {
        _vm.splitMode = $$v
      },
      expression: "splitMode"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v("是否显示全量下载设置文件按钮？")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "是",
      "inactive-text": "否",
      "active-value": true,
      "inactive-value": false
    },
    model: {
      value: (_vm.splitButton),
      callback: function($$v) {
        _vm.splitButton = $$v
      },
      expression: "splitButton"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42c83018"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/personalSetting.vue
// module id = 2416
// module chunks = 68